import * as types from './constants'

const initialState = {
	user: {},
	assessor: {},
	sections: [],
	description: {},
	managerName: '',
	courseId: '',
	groupId: '',
	status: '',
	loaded: false,
	certifyTime: '',
	referredFromManagerReport: false,
	waitingForApproval: false,
	approvalPrivilege: false,
}

const checkListReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.CHECKLIST:
			return {
				...state,
				...action.checklist,
			}
		case types.CHECKLIST_USER:
			return {
				...state,
				user: action.user,
			}
		case types.CHECKLIST_SECTION_UPDATE:
			return {
				...state,
				sections: action.sections,
			}
		case types.CHECKLIST_UPDATE:
			return {
				...state,
				[action.property]: action.value,
			}
		case types.CHECKLIST_RESET:
			return {
				...state,
				status: initialState.status,
				sections: initialState.sections,
				managerName: initialState.managerName,
				waitingForApproval: initialState.waitingForApproval,
				approvalPrivilege: initialState.approvalPrivilege,
			}
		case types.CHECKLIST_RESET_DATA:
			return {
				...state,
				...initialState,
			}
		case types.CHECKLIST_LOADED:
			return {
				...state,
				loaded: action.loaded,
			}
		case types.SET_CERTIFY_TIME:
			return {
				...state,
				certifyTime: action.value,
			}
		case types.SET_REFERRED_FROM_MANAGER_REPORT:
			return {
				...state,
				referredFromManagerReport: action.value,
			}
		case types.SET_CHECKLIST_APPROVAL:
			return {
				...state,
				waitingForApproval: action.waitingForApproval,
				approvalPrivilege: action.approvalPrivilege,
				approvedBy: action.approvedBy,
			}
		default:
			return state
	}
}
export default checkListReducer
